import { icon } from '@carvana/ds-styles';
import { ClipboardCopy } from 'lucide-react';
import { useCallback } from 'react';
import toastStyles from '~/hooks/common/ui/toast.module.css';
import useReplaceToast from '~/hooks/common/ui/useReplaceToast';

const useDisplayShareToast = () => {
  const replaceToast = useReplaceToast();

  return useCallback(
    () =>
      replaceToast({
        classes: { container: toastStyles.topCenter },
        dismissal: { duration: 5000, showDismissButton: false, type: 'timer' },
        header: 'Link copied to clipboard',
        icon: <ClipboardCopy color={icon.strong} />,
        variant: 'inverse'
      }),
    [replaceToast]
  );
};

export default useDisplayShareToast;
